

































import { Vue, Component } from 'vue-property-decorator';
import DataTable from '../components/DataTable.vue';
import { AdvanceFilterRequest } from '../types/request';
import { ObjectFactory } from '../config/objectFactory';
import { ServiceRequest } from '../types/entity';
import { DateUtils } from '../util/dateUtils';
import ViewRequestDetailModal from './modal/ViewRequestDetailModal.vue';
import { Condition } from '../types/queryRequest';
import AdvancedSearchFilterModal from '../views/modal/AdvancedSearchFilterModal.vue';
import RequestMobile from '../components/RequestMobile.vue';
import ServiceRequestDetails from './modal/ViewRequestDetailModal.vue';
import Menu from '../components/Menu.vue';

// tslint:disable-next-line: no-var-requires
const TransportationRequestsTable = require('../datatable/AllTransportRequestsTable.json');
// tslint:disable-next-line: no-var-requires
const InterpretationRequestsTable = require('../datatable/AllInterpreterRequestsTable.json');
// tslint:disable-next-line: no-var-requires
const HomeHealthCareRequestsTable = require('../datatable/AllHomeHealthCareRequestsTable.json');
// tslint:disable-next-line: no-var-requires
const TelemedicineRequestsTable = require('../datatable/AllTelemedicineRequestsTable.json');
// tslint:disable-next-line: no-var-requires
const DeliveryRequestsTable = require('../datatable/AllDeliveryRequestsTable.json');
// tslint:disable-next-line: no-var-requires
const CmrRequestsTable = require('../datatable/AllCmrRequestsTable.json');
@Component({
    watch: {
        '$route.query.requestType'() {
           const request = this as Requests;
           request.resetFilter();
           request.getServiceRequests('', 0);
        },
        '$route.query.status'() {
            const request = this as Requests;
            request.getServiceRequests();
        },
        '$route.path'(to, from) {
            if (!this.$route.params.id) {
                const request = this as Requests;
                request.getServiceRequests();
            }
        },
    },
     data() {
        return {
            header: 'Service Requests',
            options: [{
                url: 'service-requests?requestType=transportRequest',
                activeConditions: {
                    requestType: 'transportRequest',
                },
                label: 'Transportation',
            },
            {
                url: 'service-requests?requestType=interpreterRequest',
                activeConditions: {
                    requestType: 'interpreterRequest',
                },
                label: 'Interpretation',
            },
            {
                url: 'service-requests?requestType=homeHealthCareRequest',
                activeConditions: {
                    requestType: 'homeHealthCareRequest',
                },
                label: 'Home Health Care',
            },
            {
                url: 'service-requests?requestType=telemedicineRequest',
                activeConditions: {
                    requestType: 'telemedicineRequest',
                },
                label: 'Telemedicine',
            },
            {
                url: 'service-requests?requestType=deliveryRequest',
                activeConditions: {
                    requestType: 'deliveryRequest',
                },
                label: 'Delivery',
            },
            {
                url: 'service-requests?requestType=cmrRequest',
                activeConditions: {
                    requestType: 'cmrRequest',
                },
                label: 'CMR',
            },
            ],
        };
    },
    components: {
        DataTable,
        ViewRequestDetailModal,
        AdvancedSearchFilterModal,
        RequestMobile,
        Menu,
        ServiceRequestDetails,
    },
})
export default class Requests extends Vue {
    private requestType: any = '';
    private transportationDatasource = TransportationRequestsTable;
    private interpretationDatasource = InterpretationRequestsTable;
    private homeHealthCareDataSource = HomeHealthCareRequestsTable;
    private telemedicineDatasource = TelemedicineRequestsTable;
    private deliveryDatasource = DeliveryRequestsTable;
    private cmrDatasource = CmrRequestsTable;
    private status: any = '';
    private showAdvancedFilter = false;
    private advanceFilterRequest: AdvanceFilterRequest = {};
    private requestsStart = 0;
    private requestId = '';


    public mounted() {
        this.getServiceRequests('', 0);
        this.resetFilter();
    }

    private openAdvancedFilter() {
        this.showAdvancedFilter = true;
    }


    private async getServiceRequests(searchString?: string, start?: number, conditions?: Condition[]) {
        const requestType = this.$route.query.requestType;
        this.requestType = requestType ? requestType : 'transportRequest';
        const status = this.$route.query.status;
        if (searchString) {
            this.advanceFilterRequest.searchString = searchString;
        } else {
            this.advanceFilterRequest.searchString = '';
        }
        if (typeof start !== 'undefined') {
            this.requestsStart = start;
        } else if (this.requestsStart > 0) {
            start = this.requestsStart;
        }
        const response = await ObjectFactory.getRequestService().getRequests({
            baseURL: this.$store.state.serverUrl,
            advanceSearchRequest: this.advanceFilterRequest,
            service: this.requestType,
            start,
        });
        this.transportationDatasource.data = [];
        this.interpretationDatasource.data = [];
        this.homeHealthCareDataSource.data = [];
        this.telemedicineDatasource.data = [];
        this.deliveryDatasource.data = [];
        this.cmrDatasource.data = [];
        if (response.success && response.data) {
            switch (this.requestType) {
                case 'transportRequest':
                    this.getFormattedTransportationRequests(response.data);
                    if (response.totalCount) {
                        this.transportationDatasource.totalCount = response.totalCount;
                    }
                    if (this.requestsStart === 0) {
                        this.transportationDatasource.page = 1;
                    }
                    break;

                case 'interpreterRequest':
                    this.getFormattedInterpretationRequests(response.data);
                    if (response.totalCount) {
                        this.interpretationDatasource.totalCount = response.totalCount;
                    }
                    if (this.requestsStart === 0) {
                        this.interpretationDatasource.page = 1;
                    }
                    break;
                case 'homeHealthCareRequest':
                    this.getFormattedHomeHealthCareRequests(response.data);
                    if (response.totalCount) {
                        this.homeHealthCareDataSource.totalCount = response.totalCount;
                    }
                    if (this.requestsStart === 0) {
                        this.homeHealthCareDataSource.page = 1;
                    }
                    break;
                case 'telemedicineRequest':
                    this.getFormattedTelemedicineRequests(response.data);
                    if (response.totalCount) {
                        this.telemedicineDatasource.totalCount = response.totalCount;
                    }
                    if (this.requestsStart === 0) {
                        this.telemedicineDatasource.page = 1;
                    }
                    break;
                case 'deliveryRequest':
                    this.getFormattedDeliveryRequests(response.data);
                    if (response.totalCount) {
                        this.deliveryDatasource.totalCount = response.totalCount;
                    }
                    if (this.requestsStart === 0) {
                        this.deliveryDatasource.page = 1;
                    }
                    break;
                 case 'cmrRequest':
                    this.getFormattedCmrRequests(response.data);
                    if (response.totalCount) {
                        this.cmrDatasource.totalCount = response.totalCount;
                    }
                    if (this.requestsStart === 0) {
                        this.cmrDatasource.page = 1;
                    }
                    break;
            }
        }
    }

    private getFormattedTransportationRequests(result: ServiceRequest[]) {
        result.forEach((element: any) => {
            element.appointment.date = DateUtils.formatDate(element.appointment.date, DateUtils.FORMAT_DATETIME_AM_PM);
            element.appointment.timestamp = DateUtils.formatDate(element.appointment.timestamp,
            DateUtils.FORMAT_DATETIME_AM_PM , element.appointment.facility.address.timezone);
        });
        this.transportationDatasource.data = result;
    }

    private getFormattedInterpretationRequests(result: ServiceRequest[]) {
        result.forEach((element: any) => {
            element.appointment.date =
                DateUtils.formatDate(element.appointment.date, DateUtils.FORMAT_DATETIME_AM_PM);
            element.appointment.timestamp =
                DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM);
        });
        this.interpretationDatasource.data = result;
    }

    private getFormattedHomeHealthCareRequests(result: ServiceRequest[]) {
        result.forEach((element: any) => {
            element.appointment.date =
                DateUtils.formatDate(element.appointment.date, DateUtils.FORMAT_DATETIME_AM_PM);
            element.appointment.timestamp =
                DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM);
        });
        this.homeHealthCareDataSource.data = result;
    }

    private getFormattedTelemedicineRequests(result: ServiceRequest[]) {
        result.forEach((element: ServiceRequest) => {
            element.appointment.date = DateUtils.formatDate(element.appointment.date
                , DateUtils.FORMAT_DATETIME_AM_PM) as any;
            element.appointment.timestamp =
                DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM) as any;
        });
        this.telemedicineDatasource.data = result;
    }

    private getFormattedCmrRequests(result: ServiceRequest[]) {
        result.forEach((element: ServiceRequest) => {
            element.appointment.date = DateUtils.formatDate(element.appointment.date
                , DateUtils.FORMAT_DATETIME_AM_PM) as any;
            element.appointment.timestamp =
                DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM) as any;
        });
        this.cmrDatasource.data = result;
    }

    private getFormattedDeliveryRequests(result: ServiceRequest[]) {
        result.forEach((element: any) => {
            element.appointment.date =
                DateUtils.formatDate(element.appointment.date, DateUtils.FORMAT_DATETIME_AM_PM);
            element.appointment.timestamp =
                DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM);
            element.deliveryRequest.deliveryItems.forEach((item: string) => {
                if (element.deliveryItems) {
                    element.deliveryItems = `${element.deliveryItems}, ${item}`;
                } else {
                    element.deliveryItems = `${item}`;
                }
            });
        });
        this.deliveryDatasource.data = result;
    }

    private showViewRequestModal(serviceRequest: any) {
        this.requestId = serviceRequest.id;
    }



    private resetFilter() {
        this.advanceFilterRequest = {
            appointmentDate: {},
        };
    }

    private async filterRequests(filter: any) {
        this.getServiceRequests('', 0);
    }

}
